<script setup>
import { RouterView } from 'vue-router'
import Sidebar from "@/components/layout/Sidebar.vue";
import ThemeToggle from "@/components/ThemeToggle.vue";
import LanguageToggle from "@/components/LanguageToggle.vue";
import NotificationBell from "@/components/notifications/NotificationBell.vue";
import SubscriptionGate from "@/components/subscription/SubscriptionGate.vue";
import TrialBanner from "@/components/subscription/TrialBanner.vue";
</script>

<template>
  <div class="min-h-screen bg-background cyber-grid flex overflow-hidden">
    <!-- Sidebar - permanece vivo entre navegaciones -->
    <Sidebar />

    <!-- Main Content Area -->
    <main class="flex-1 h-screen overflow-y-auto relative bg-background/50">
      <!-- Top bar for utilities (like ThemeToggle) -->
      <div class="absolute top-4 right-6 z-30 flex items-center gap-2">
        <NotificationBell />
        <LanguageToggle />
        <ThemeToggle />
      </div>

      <TrialBanner />

      <div class="container mx-auto px-6 py-8 pt-16">
        <!-- Las rutas hijas se renderizan aquí -->
        <RouterView />
      </div>
    </main>

    <!-- Subscription popups (non-dismissible) -->
    <SubscriptionGate />
  </div>
</template>
